import React from 'react';
import ReactDOM from 'react-dom/client';
import store from './store/Store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import RootRoutes from './routes/RootRoutes';
import { BackdropLoader } from './components/BackdropLoader';
import './styles.scss';
import { GlobalNotification } from './components/NotificationSnackbar';
import { AlertDialog } from './components/Dialog/AlertDialog';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <Router>
      <GlobalNotification />
      <BackdropLoader />
      <AlertDialog />
      <RootRoutes />
    </Router>
  </Provider>,
);
